<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="table">
          <table class="table">
            <thead class=" text-primary">
              <tr>
                <th>System Name</th>
                <th>Display Name</th>
                <th>
                  <router-link
                    v-if="$dataManager.getters.permissions.Player.includes('create')"
                    :to="{name:'Player.Create'}"
                  >
                    <div class="btn btn-xs btn-success btn-round pull-right">Create</div>
                  </router-link>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in player" :key="i">
                <td v-text="item.name" />
                <td v-text="item.displayName" />
                <td>
                  <router-link
                    v-if="$dataManager.getters.permissions.Player.includes('update')"
                    :to="{name:'Player.Update',params:{id:item.id}}"
                  >
                    <div class="btn btn-xs btn-primary  pull-right">Update</div>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PlayerList',
  data: function() {
    return {
      player: []
    }
  },
  computed: {
    ...mapGetters([
      'permissions'
    ])
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData: function() {
      this.$store.commit('OPEN_LOADING')

      this.$store.dispatch('getList', { type: 'Player', action: 'list' }).then((res) => {
        if (!res.errorCode) {
          this.$store.commit('CLOSE_LOADING')

          this.player = res.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
